module.exports = __webpack_public_path__ + "img/tournament-bg_460.9323424a.png";